import { forwardRef, type TdHTMLAttributes } from 'react'
import { cn } from '#src/cn.ts'

export const TableCell = forwardRef<
  HTMLTableCellElement,
  TdHTMLAttributes<HTMLTableCellElement>
>(({ className, ...props }, ref) => (
  <td
    ref={ref}
    className={cn('p-4 align-middle has-[[role=checkbox]]:pr-0', className)}
    {...props}
  />
))
TableCell.displayName = 'TableCell'
